// §10.6: per-cycle summary bar. One chip per cycle; click toggles
// collapse of all timeline events for that cycle.

import React from 'react';
import type { OpportunityEvent } from '../../../types/pipeline';
import { computeCycleSummaries } from './state';

interface Props {
  events: OpportunityEvent[];
  collapsedCycles: Record<number, boolean>;
  onToggle: (cycle: number) => void;
}

const DealCycleBar: React.FC<Props> = ({
  events,
  collapsedCycles,
  onToggle,
}) => {
  const summaries = computeCycleSummaries(events);
  if (summaries.length === 0) return null;

  return (
    <div className="flex gap-1 mb-3">
      {summaries.map((s) => {
        const isCollapsed = !!collapsedCycles[s.cycle];
        const closeBg =
          s.closeKind === 'won'
            ? 'bg-ok'
            : s.closeKind === 'lost'
              ? 'bg-danger'
              : 'bg-accent';
        const closeText =
          s.closeKind === 'won'
            ? 'text-ok-text'
            : s.closeKind === 'lost'
              ? 'text-danger-text'
              : 'text-accent-text';
        return (
          <button
            key={s.cycle}
            type="button"
            onClick={() => onToggle(s.cycle)}
            title={isCollapsed ? `Expand cycle ${s.cycle}` : `Collapse cycle ${s.cycle}`}
            className={`flex-1 text-left bg-surface-2 border border-white/[0.08] rounded-md px-2.5 py-2 hover:bg-white/[0.06] transition ${
              isCollapsed ? 'opacity-60' : ''
            }`}
          >
            <div className="flex items-center justify-between gap-1.5">
              <span className="text-[10px] font-mono uppercase text-slate-400">
                cycle {s.cycle}
              </span>
              <span className="text-[9px] text-slate-500">
                {isCollapsed ? '▸ expand' : '▾ collapse'}
              </span>
            </div>
            <div className={`h-1 rounded mt-1.5 opacity-70 ${closeBg}`} />
            <div className="text-[10px] text-slate-400 font-mono mt-1">
              {s.events.length} events ·{' '}
              <span className={closeText}>{s.closeKind ?? 'open'}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default DealCycleBar;
